import React, { useRef, useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";

const translateSeverityLabel = (severity, t) => {
    if (severity === "Low") return t("riskCenter.levels.low");
    if (severity === "Moderate") return t("riskCenter.levels.moderate");
    if (severity === "High") return t("riskCenter.levels.high");
    return severity;
};


const formatTopRisksData = (data) => {
    const impactMapping = {
        Insignificant: 0,
        Minor: 1,
        Moderate: 2,
        Major: 3,
        Catastrophe: 4,
    };

    const probabilityMapping = {
        Rare: 0,
        Unlikely: 1,
        Possible: 2,
        Likely: 3,
        "Almost Certain": 4,
    };

    //////console.log("top 5 risk data", data);
  

    return (
        data &&
        data
            .filter(item => 
                item.financial_impact &&
                item.operational_impact &&
                item.reputational_impact &&
                item.probability
            )
            .map((item) => {
                const financialScore = impactMapping[item.financial_impact] || 0;
                const operationalScore = impactMapping[item.operational_impact] || 0;
                const reputationalScore = impactMapping[item.reputational_impact] || 0;
                const probabilityScore = probabilityMapping[item.probability] || 0;

                const averageScore =
                    (financialScore + operationalScore + reputationalScore) / 3;
                // Determine risk level
                let riskLevel = "Undefined";
                if ((averageScore === 0 && probabilityScore === 0) || (probabilityScore<=1 && averageScore <= 2) || (probabilityScore===0 && averageScore === 1)) {
                    riskLevel = "Low";
                } else if (
                    (probabilityScore <= 2 &&
                    averageScore > 0 &&
                    averageScore < 2)|| (probabilityScore == 0 && averageScore > 1) ||  (probabilityScore <=1 && averageScore <= 2.5)
                ) {
                    riskLevel = "Moderate";
                } else if (
                    (probabilityScore >= 2 &&
                    averageScore > 1.5 &&
                    averageScore <= 2.5) ||
                    (probabilityScore == 2 && averageScore > 2) 
                    
                ) {
                    riskLevel = "High";
                } else if (
                    (probabilityScore >= 3 &&
                    averageScore > 2.5) ||
                    (probabilityScore >= 4 &&
                        averageScore > 1.5) ||
                    (probabilityScore >= 3 &&
                        averageScore > 3.5)
                ) {
                    riskLevel = "Extreme";
                } else if (averageScore > 0) {
                    // Fallback for unclassified risks
                    ////console.log("probabilityScore", probabilityScore)
                    ////console.log("averageScore", averageScore)
                    riskLevel = "Fall Back";
                }

                //////console.log(riskLevel);

                // Assign color based on risk level
                let color;
                switch (riskLevel) {
                    case "High":
                        color = "#FED4AE";
                        break;
                    case "Extreme":
                        color = "#F07167";
                        break;
                    case "Moderate":
                        color = "#09A6B0";
                        break;
                    case "Low":
                        color = "#05769D";
                        break;
                    default:
                        color = "#05769D"; // Undefined
                }

                return {
                    name: item.title,
                    severity: riskLevel,
                    color: color,
                    financial_score: financialScore,
                    operational_score: operationalScore,
                    reputational_score: reputationalScore,
                    probability_score: probabilityScore,
                };
            })
            // Step 2: Sort risks by ranking logic
            .sort((a, b) => {
    // Compute total impact scores
    const aTotalScore = (a.financial_score || 0) + (a.operational_score || 0) + (a.reputational_score || 0);
    const bTotalScore = (b.financial_score || 0) + (b.operational_score || 0) + (b.reputational_score || 0);

    if (bTotalScore !== aTotalScore) {
        return bTotalScore - aTotalScore; // Higher total impact first
    }

    return (b.financial_score || 0) - (a.financial_score || 0); // If equal, prioritize financial score
})
            // Step 3: Take top 5 risks
            .slice(0, 5)
    );
};


/*const data2 = [
    { name: 'Risk 1', severity: 'High', color: 'TOP_RISK_YELLOW' },
    { name: 'Risk 2', severity: 'Extreme', color: 'TOP_RISK_YELLOW' },
    { name: 'Risk 3', severity: 'High', color: 'TOP_RISK_YELLOW' },
    { name: 'Risk 4', severity: 'Extreme', color: 'TOP_RISK_RED' },
    { name: 'Risk 5', severity: 'Extreme', color: 'TOP_RISK_RED' },
];*/

const TopRisks = ({ height, data }) => {
    const { t } = useTranslation();

    ////////console.log(data);

    const newData = formatTopRisksData(data);
    ////////console.log(newData);


   // const newData = formatTopRisksData(formattedData);
    const containerRef = useRef(null);
    const [containerSize, setContainerSize] = useState({ width: 0, height: 0 });

    useEffect(() => {
        if (containerRef.current) {
            setContainerSize({
                width: containerRef.current.offsetWidth,
                height: containerRef.current.offsetHeight,
            });
        }
    }, []);

    // ////////console.log(data);

    //////////console.log(newData);


    // Check if no data available
    if (!newData || newData.length === 0) {
        return (
            <div
                ref={containerRef}
                className="top-risks flex flex-col h-full p-2 items-center justify-center"
                style={{
                    height: `${height}px`,
                    maxHeight: '400px',
                }}
            >
                <div className="text-center text-gray-500">
                    <svg 
                        className="mx-auto mb-2 text-gray-300" 
                        width="48" 
                        height="48" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        stroke="currentColor" 
                        strokeWidth="2"
                    >
                        <path d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
                    </svg>
                    <p className="text-sm">No risk data available</p>
                </div>
            </div>
        );
    }

    return (
<div
    ref={containerRef}
    className="top-risks flex flex-col h-full p-2 overflow-y-auto"
    style={{
        height: `${height}px`, // Ensure the height is dynamic based on the provided prop
        maxHeight: '400px', // Set a fixed max height for the list window
    }}
>
    <div className="flex flex-col justify-between">
        {newData.map((risk, index) => (
                <div
                    key={index}
                    className="risk-item flex justify-between items-center flex-1 mt-2 mb-2"
                    style={{ minHeight: 0 }}
                >
                    {/* Risk Name */}
                    <span
                        className="text-black text-left break-words text-base md:text-lg lg:text-lg"
                        style={{
                            width: 'calc(100%)', // Ensure the name fits while leaving space for severity
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }}
                    >
                        {`${index + 1}. ${risk.name}`}
                    </span>

                    {/* Risk Severity */}
                    <span
                        className="rounded-md text-sm px-2 py-2 text-white text-center"
                        style={{
                            height: '32px', // Fixed height for severity box
                            width: '76px', // Fixed width
                            backgroundColor: risk.color,
                            flexShrink: 0, // Prevent resizing
                        }}
                    >
                        {translateSeverityLabel(risk.severity, t)}
                    </span>
                </div>
            ))}
    </div>
</div>
    );
};

export default TopRisks;
